import { render, staticRenderFns } from "./AdminChatInput.vue?vue&type=template&id=3302991f&"
import script from "./AdminChatInput.vue?vue&type=script&lang=js&"
export * from "./AdminChatInput.vue?vue&type=script&lang=js&"
import style0 from "./AdminChatInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports